import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";

interface PaymentHeaderProps {
  view: boolean;
  onAddClick: () => void;
}

const PaymentHeader: React.FC<PaymentHeaderProps> = ({ view, onAddClick }) => {
  const { t } = useTranslation();

  return (
    <div className="row mb-6">
      <div className="col-12 d-flex justify-content-end">
        {
          !view && <Button
            className="btn btn-primary waves-effect waves-light"
            text={t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.header.addPaymentButton')}
            onClick={onAddClick}
          />
        }
      </div>
    </div>
  );
};

export default PaymentHeader;
